export const CopyRound = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <circle cx='12' cy='12' r='12' fill='#1A1519' fillOpacity='0.1'></circle>
        <path
          stroke='#1A1519'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M14.487 12.532l.865-.865a2.135 2.135 0 10-3.02-3.019l-1.85 1.85a2.134 2.134 0 000 3.02l-.005.005c.172.169.373.307.592.408m.811-2.812c.22.102.42.24.592.41a2.134 2.134 0 010 3.018l-1.85 1.85a2.135 2.135 0 01-3.02-3.019l.866-.865'
        ></path>
      </svg>
    </span>
  );
};
